import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { api, formatError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

// Enlace de invitación o de recuperación: elegir contraseña (un solo uso).
export default function ResetPassword() {
  const location = useLocation();
  const navigate = useNavigate();
  // El token va en el fragmento (#token=…): no llega al servidor web ni a sus registros.
  const token = new URLSearchParams(location.hash.replace(/^#/, "")).get("token")
    || new URLSearchParams(location.search).get("token") || "";
  const [pwd, setPwd] = useState({ a: "", b: "" });
  const [error, setError] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (pwd.a !== pwd.b) return setError("Las dos contraseñas no coinciden");
    try {
      await api.post("/auth/reset", { token, password: pwd.a });
      toast.success("Contraseña guardada. Ya puedes entrar.");
      navigate("/admin/login");
    } catch (err) {
      setError(formatError(err));
    }
  };
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F7F5F0] px-4">
      <form onSubmit={submit} className="w-full max-w-md bg-white border border-[#DCD8D0] rounded-xl p-8 space-y-4">
        <h1 className="font-display text-2xl font-bold text-[#1A1A1A]">Elige tu contraseña</h1>
        <div><Label htmlFor="rp-a">Contraseña (10 caracteres o más)</Label>
          <Input id="rp-a" type="password" required minLength={10} autoComplete="new-password" className="mt-1 bg-[#F7F5F0] border-[#DCD8D0]" value={pwd.a} onChange={(e) => setPwd((d) => ({ ...d, a: e.target.value }))} data-testid="reset-a" />
        </div>
        <div><Label htmlFor="rp-b">Repítela</Label>
          <Input id="rp-b" type="password" required minLength={10} autoComplete="new-password" className="mt-1 bg-[#F7F5F0] border-[#DCD8D0]" value={pwd.b} onChange={(e) => setPwd((d) => ({ ...d, b: e.target.value }))} data-testid="reset-b" />
        </div>
        {error && <p className="text-sm text-acento" data-testid="reset-error">{error}</p>}
        <Button type="submit" className="w-full bg-marca hover:bg-marca-hover text-white" data-testid="reset-save">Guardar</Button>
        <Link to="/admin/login" className="text-sm underline">Volver a entrar</Link>
      </form>
    </div>
  );
}
